import { Controller } from "@hotwired/stimulus"

/**
 * Auto-dismiss Controller
 *
 * Removes its host element after a configurable delay. Primarily used for
 * transient toast alerts that should self-clear so the DOM doesn't grow
 * unbounded during long sessions (e.g. the kiosk page that prepends a toast
 * on every scan).
 *
 * Usage:
 *   <div data-controller="auto-dismiss"
 *        data-auto-dismiss-delay-value="3000">...</div>
 */
export default class extends Controller<HTMLElement> {
  static values = { delay: { type: Number, default: 3000 } }

  declare readonly delayValue: number

  private timer: ReturnType<typeof setTimeout> | null = null

  connect() {
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = null
  }

  dismiss() {
    // Fade-out then remove. Honors prefers-reduced-motion via CSS.
    this.element.classList.add("transition-opacity", "duration-300", "opacity-0")
    setTimeout(() => this.element.remove(), 320)
  }
}
